/*
 * @Description: VIP管理页面设置路由
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/pcHome.vue'
const vipManagement: Array<RouteRecordRaw> = [
	{
		path: '/vipManagement',
		component: Layout,
		redirect: '/vipManagement/vipAccountManageList',
		children: [
			{
				path: 'vipAccountManageList',
				component: () => import(/* webpackChunkName: "vipAccountManageList" */ '@/views/vipManagement/vipAccountManageList/index.vue'),
				name: 'vipAccountManageList',
				meta: { title: 'VIP管理' }
			}
		]
	}
]

export default vipManagement
